<template>
  <div>
    <v-row class="px-5 item-row">
      <v-col cols="8">
        <span class="red--text font-weight-thin">{{ name }}</span>
      </v-col>
      <v-col cols="4" class="text-right">
        <span class="price red--text">- {{ discount | numFormat('0,0.00') }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "DiscountRow",
    props: {
      name: { type: String, default: '' },
      discount: { type: Number, default: 0 }
    },
    data: () => ({
      //
    })
  }
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.price {
  text-align: right;
  font-weight: normal;
}

.item-row {
  color: black;
}
</style>